import { Buffergs925ekssbch as Buffer } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Buffer.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { readAvailable27gpepp0hyyts as readAvailable } from './core/Input.mjs';
import { BytePacketBuilder2biodf4wxvlba as BytePacketBuilder } from './core/BytePacketBuilder.mjs';
import { readBytesj5m5qe40si0k as readBytes } from './core/Buffers.mjs';
import {
  get_remaining1lapv95kcmm0y as get_remaining,
  discard3ugntd47xyll6 as discard,
} from './core/ByteReadPacket.mjs';
import {
  subtract2orl8z9upxd9l as subtract,
  fromInt2ii0rejb1w62w as fromInt,
  numberToLong2pakxeg38estk as numberToLong,
  convertToInty04h231mmjoh as convertToInt,
  add2suhfggl4zvkk as add,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { close3semq7pafb42g as close } from './ByteWriteChannelOperations.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { EOFExceptionh831u25jcq9n as EOFException } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/-PlatformJs.mjs';
import { ByteChannelScanner1h148q1m3y1ey as ByteChannelScanner } from './ByteChannelScanner.mjs';
import {
  LineEnding_Default_getInstance2rn2jcwspqdym as LineEnding_Default_getInstance,
  LineEnding_Lenient_getInstance3fqbz71y17kis as LineEnding_Lenient_getInstance,
} from './LineEnding.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { readByteString2hnsbql6t4ads as readByteString } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/ByteStrings.mjs';
import { indexOf29nspdgx2e3ap as indexOf } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Sources.mjs';
import { TooLongLineException2d6ls946t46wx as TooLongLineException } from './charsets/Encoding.mjs';
import {
  readStringo8i62qxt5m4m as readString,
  readString3v6duspiz33tv as readString_0,
} from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Utf8.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *readBuffer(_this__u8e3s4, $completion) {
  var result = new (Buffer())();
  while (!_this__u8e3s4.d4k()) {
    result.z4g(_this__u8e3s4.l4j());
    yield* _this__u8e3s4.k4k(VOID, $completion);
  }
  var tmp0_safe_receiver = _this__u8e3s4.y4j();
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    throw tmp0_safe_receiver;
  }
  return result;
}
function *readAvailable_0(_this__u8e3s4, buffer, offset, length, $completion) {
  offset = offset === VOID ? 0 : offset;
  length = length === VOID ? buffer.length - offset | 0 : length;
  if (_this__u8e3s4.d4k())
    return -1;
  if (_this__u8e3s4.l4j().v3v()) {
    yield* _this__u8e3s4.k4k(VOID, $completion);
  }
  if (_this__u8e3s4.d4k())
    return -1;
  return readAvailable(_this__u8e3s4.l4j(), buffer, offset, length);
}
function *readRemaining(_this__u8e3s4, $completion) {
  var result = BytePacketBuilder();
  while (!_this__u8e3s4.d4k()) {
    result.z4g(_this__u8e3s4.l4j());
    yield* _this__u8e3s4.k4k(VOID, $completion);
  }
  rethrowCloseCauseIfNeeded(_this__u8e3s4);
  return result.u3v();
}
function *toByteArray(_this__u8e3s4, $completion) {
  return readBytes(yield* /*#__NOINLINE__*/readBuffer(_this__u8e3s4, $completion));
}
function *copyTo(_this__u8e3s4, channel, limit, $completion) {
  var remaining = limit;
  try {
    while (!_this__u8e3s4.d4k() && remaining > 0n) {
      if (_this__u8e3s4.l4j().v3v()) {
        yield* _this__u8e3s4.k4k(VOID, $completion);
      }
      var tmp0 = remaining;
      // Inline function 'kotlin.comparisons.minOf' call
      var b = get_remaining(_this__u8e3s4.l4j());
      var count = tmp0 <= b ? tmp0 : b;
      _this__u8e3s4.l4j().l4g(channel.r4j(), count);
      remaining = subtract(remaining, count);
      yield* channel.l4k($completion);
    }
  } catch ($p) {
    if ($p instanceof Error) {
      var cause = $p;
      _this__u8e3s4.o4k(cause);
      close(channel, cause);
      throw cause;
    } else {
      throw $p;
    }
  }
  finally {
    yield* channel.l4k($completion);
  }
  return subtract(limit, remaining);
}
function rethrowCloseCauseIfNeeded(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.y4j();
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    throw tmp0_safe_receiver;
  }
}
function *discard_0(_this__u8e3s4, max, $completion) {
  max = max === VOID ? 9223372036854775807n : max;
  var remaining = max;
  while (remaining > 0n && !_this__u8e3s4.d4k()) {
    if (get_availableForRead(_this__u8e3s4) === 0) {
      yield* _this__u8e3s4.k4k(VOID, $completion);
    }
    var tmp0 = remaining;
    // Inline function 'kotlin.comparisons.minOf' call
    var b = get_remaining(_this__u8e3s4.l4j());
    var count = tmp0 <= b ? tmp0 : b;
    discard(_this__u8e3s4.l4j(), count);
    remaining = subtract(remaining, count);
  }
  return subtract(max, remaining);
}
function *skipIfFound(_this__u8e3s4, byteString, $completion) {
  if (equals(yield* peek(_this__u8e3s4, byteString.q2(), $completion), byteString)) {
    yield* /*#__NOINLINE__*/discard_0(_this__u8e3s4, fromInt(byteString.q2()), $completion);
    return true;
  }
  return false;
}
function *readPacket(_this__u8e3s4, packet, $completion) {
  var result = new (Buffer())();
  $l$loop: while (result.q2() < fromInt(packet)) {
    if (_this__u8e3s4.l4j().v3v()) {
      yield* _this__u8e3s4.k4k(VOID, $completion);
    }
    if (_this__u8e3s4.d4k())
      break $l$loop;
    if (get_remaining(_this__u8e3s4.l4j()) > subtract(numberToLong(packet), result.q2())) {
      _this__u8e3s4.l4j().l4g(result, subtract(numberToLong(packet), result.q2()));
    } else {
      _this__u8e3s4.l4j().m4g(result);
    }
  }
  if (result.q2() < fromInt(packet)) {
    throw EOFException().o4f('Not enough data available, required ' + packet + ' bytes but only ' + result.q2().toString() + ' available');
  }
  return result;
}
function *readUntil(_this__u8e3s4, matchString, writeChannel, limit, ignoreMissing, $completion) {
  limit = limit === VOID ? 9223372036854775807n : limit;
  ignoreMissing = ignoreMissing === VOID ? false : ignoreMissing;
  return yield* (new (ByteChannelScanner())(_this__u8e3s4, matchString, writeChannel, limit)).z4k(ignoreMissing, $completion);
}
function *readLineStrictTo(_this__u8e3s4, out, limit, lineEnding, $completion) {
  limit = limit === VOID ? 9223372036854775807n : limit;
  lineEnding = lineEnding === VOID ? LineEnding_Default_getInstance() : lineEnding;
  // Inline function 'kotlin.require' call
  if (!(limit >= 0n)) {
    var message = 'Limit (' + limit.toString() + ') should be non-negative';
    throw IllegalArgumentException().n2(toString(message));
  }
  return yield* internalReadLineTo(_this__u8e3s4, out, limit, lineEnding.equals(LineEnding_Lenient_getInstance()), true, $completion);
}
function rethrowCloseCauseIfNeeded_0(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.y4j();
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    throw tmp0_safe_receiver;
  }
}
function get_availableForRead(_this__u8e3s4) {
  return convertToInt(_this__u8e3s4.l4j().u3v().q2());
}
function *peek(_this__u8e3s4, count, $completion) {
  if (_this__u8e3s4.d4k())
    return null;
  if (!(yield* _this__u8e3s4.e4k(count, $completion)))
    return null;
  return readByteString(_this__u8e3s4.l4j().w3x(), count);
}
function *internalReadLineTo(_this__u8e3s4, out, limit, lenientLineEnding, throwOnIncompleteLine, $completion) {
  var readBuffer = _this__u8e3s4.l4j();
  if (readBuffer.v3v()) {
    yield* _this__u8e3s4.k4k(VOID, $completion);
  }
  if (_this__u8e3s4.d4k())
    return -1n;
  var consumed = {_v: 0n};
  var outBuffer = {_v: null};
  try {
    $l$loop: while (consumed._v < limit && !_this__u8e3s4.d4k()) {
      var limitLeft = subtract(limit, consumed._v);
      var lfIndex = indexOf(readBuffer, 10, VOID, limitLeft);
      var crIndex = internalReadLineTo$scanForSoleCr(readBuffer, lenientLineEnding, lfIndex, limitLeft);
      if (crIndex >= 0n) {
        internalReadLineTo$appendOrBuffer(outBuffer, out, readBuffer, consumed, crIndex);
        discard(readBuffer, 1n);
        return consumed._v;
      }
      if (lfIndex === 0n) {
        discard(readBuffer, 1n);
        return consumed._v;
      }
      if (lfIndex > 0n) {
        var tmp;
        var tmp_0 = readBuffer.u3v();
        // Inline function 'kotlin.Long.minus' call
        var tmp$ret$0 = subtract(lfIndex, fromInt(1));
        if (tmp_0.y3t(tmp$ret$0) === 13) {
          tmp = 1n;
        } else {
          tmp = 0n;
        }
        var isCrlf = tmp;
        internalReadLineTo$appendOrBuffer(outBuffer, out, readBuffer, consumed, subtract(lfIndex, isCrlf));
        discard(readBuffer, add(numberToLong(1), isCrlf));
        return consumed._v;
      }
      // Inline function 'kotlin.comparisons.minOf' call
      var b = get_remaining(readBuffer);
      var count = limitLeft <= b ? limitLeft : b;
      var tmp_1 = readBuffer.u3v();
      // Inline function 'kotlin.Long.minus' call
      var tmp$ret$2 = subtract(count, fromInt(1));
      if (tmp_1.y3t(tmp$ret$2) === 13) {
        // Inline function 'kotlin.Long.minus' call
        var tmp$ret$3 = subtract(count, fromInt(1));
        internalReadLineTo$appendOrBuffer(outBuffer, out, readBuffer, consumed, tmp$ret$3);
        if (yield* internalReadLineTo$discardCrlfOrCr(readBuffer, _this__u8e3s4, lenientLineEnding, $completion)) {
          return consumed._v;
        } else {
          internalReadLineTo$bufferBytes(outBuffer, readBuffer, consumed, 1n);
        }
      } else {
        internalReadLineTo$bufferBytes(outBuffer, readBuffer, consumed, count);
      }
      if (consumed._v < limit && get_remaining(readBuffer) === 0n && !(yield* _this__u8e3s4.k4k(VOID, $completion)))
        break $l$loop;
    }
    if (consumed._v === 0n && _this__u8e3s4.d4k())
      return -1n;
    // Inline function 'kotlin.check' call
    if (!(consumed._v <= limit)) {
      var message = 'Consumed bytes exceed the limit: ' + consumed._v.toString() + ' > ' + limit.toString() + ". It's an implementation bug, please report it.";
      throw IllegalStateException().o(toString(message));
    }
    if (consumed._v === limit) {
      if (limit === 9223372036854775807n)
        throw TooLongLineException().j4l('Max line length exceeded');
      if (get_remaining(readBuffer) === 0n && !(yield* _this__u8e3s4.k4k(VOID, $completion))) {
        throwEndOfStreamException(consumed._v);
      }
      var tmp0_subject = readBuffer.u3v().y3t(0n);
      if (tmp0_subject === 10) {
        discard(readBuffer, 1n);
        return consumed._v;
      } else if (tmp0_subject === 13)
        if (yield* internalReadLineTo$discardCrlfOrCr(readBuffer, _this__u8e3s4, lenientLineEnding, $completion)) {
          return consumed._v;
        }
      throwTooLongLineException(limit);
    }
    if (throwOnIncompleteLine) {
      throwEndOfStreamException(consumed._v);
    }
    return consumed._v;
  }finally {
    if (!(outBuffer._v == null)) {
      out.o2(readString(outBuffer._v));
    }
  }
}
function throwEndOfStreamException(consumed) {
  throw EOFException().o4f('Unexpected end of stream after reading ' + consumed.toString() + ' bytes');
}
function throwTooLongLineException(limit) {
  throw TooLongLineException().j4l('Line exceeds limit of ' + limit.toString() + ' bytes');
}
function rethrowCloseCauseIfNeeded_1(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.y4j();
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    throw tmp0_safe_receiver;
  }
}
function internalReadLineTo$bufferBytes(outBuffer, readBuffer, consumed, count) {
  if (count > 0n) {
    if (outBuffer._v == null) {
      outBuffer._v = new (Buffer())();
    }
    outBuffer._v.u4g(readBuffer, count);
    consumed._v = add(consumed._v, count);
  }
}
function internalReadLineTo$appendOrBuffer(outBuffer, $out, readBuffer, consumed, count) {
  if (outBuffer._v == null) {
    if (count > 0n) {
      $out.o2(readString_0(readBuffer, count));
      consumed._v = add(consumed._v, count);
    }
  } else {
    internalReadLineTo$bufferBytes(outBuffer, readBuffer, consumed, count);
  }
}
function internalReadLineTo$scanForSoleCr(_this__u8e3s4, $lenientLineEnding, lfIndex, limitLeft) {
  if (!$lenientLineEnding)
    return -1n;
  var tmp;
  if (lfIndex === -1n) {
    // Inline function 'kotlin.Long.minus' call
    var this_0 = get_remaining(_this__u8e3s4);
    // Inline function 'kotlin.comparisons.minOf' call
    var b = subtract(this_0, fromInt(1));
    tmp = limitLeft <= b ? limitLeft : b;
  } else if (lfIndex === 0n) {
    tmp = 0n;
  } else {
    // Inline function 'kotlin.Long.minus' call
    tmp = subtract(lfIndex, fromInt(1));
  }
  var endIndex = tmp;
  return indexOf(_this__u8e3s4, 13, VOID, endIndex);
}
function *internalReadLineTo$discardCrlfOrCr(_this__u8e3s4, $this_internalReadLineTo, $lenientLineEnding, $completion) {
  if ((get_remaining(_this__u8e3s4) >= 2n || (yield* $this_internalReadLineTo.e4k(2, $completion))) && _this__u8e3s4.u3v().y3t(1n) === 10) {
    discard(_this__u8e3s4, 2n);
    return true;
  }
  if ($lenientLineEnding) {
    discard(_this__u8e3s4, 1n);
    return true;
  }
  return false;
}
//region block: exports
export {
  copyTo as copyTo1e8cxw3cmqjst,
  readAvailable_0 as readAvailable2yaaricqompas,
  readLineStrictTo as readLineStrictTo30g42df56og5l,
  readPacket as readPacket25aqlhslm04t6,
  readRemaining as readRemaining1kbpbgdrq25q1,
  readUntil as readUntil13nwpwqdlw2vo,
  skipIfFound as skipIfFound2z2la3mzzpubl,
  toByteArray as toByteArray1nbmiiav9igm0,
  rethrowCloseCauseIfNeeded_0 as rethrowCloseCauseIfNeededeln8lm5agg4u,
  rethrowCloseCauseIfNeeded as rethrowCloseCauseIfNeeded3ixo8wl4o3bz4,
  rethrowCloseCauseIfNeeded_1 as rethrowCloseCauseIfNeeded2q8fs9csuucwc,
};
//endregion

//# sourceMappingURL=ByteReadChannelOperations.mjs.map
